var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"},[_c('md-card',[_c('md-card-content',[_c('b-container',{attrs:{"fluid":""}},[_c('bemor-form')],1)],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }